import createIcon from '../../createIcon';

/**
 * @component @name FiberPin
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS41IDEwLjVINy41VjExLjVINS41VjEwLjVaTTIwIDRINEMyLjg5IDQgMi4wMSA0Ljg5IDIuMDEgNkwyIDE4QzIgMTkuMTEgMi44OSAyMCA0IDIwSDIwQzIxLjExIDIwIDIyIDE5LjExIDIyIDE4VjZDMjIgNC44OSAyMS4xMSA0IDIwIDRaTTkgMTEuNUM5IDEyLjM1IDguMzUgMTMgNy41IDEzSDUuNVYxNUg0VjlINy41QzguMzUgOSA5IDkuNjUgOSAxMC41VjExLjVaTTEyLjUgMTVIMTFWOUgxMi41VjE1Wk0yMCAxNUgxOC44TDE2LjI1IDExLjVWMTVIMTVWOUgxNi4yNUwxOC43NSAxMi41VjlIMjBWMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FiberPin = createIcon('FiberPin', [
  [
    'path',
    {
      d: 'M5.5 10.5H7.5V11.5H5.5V10.5ZM20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM9 11.5C9 12.35 8.35 13 7.5 13H5.5V15H4V9H7.5C8.35 9 9 9.65 9 10.5V11.5ZM12.5 15H11V9H12.5V15ZM20 15H18.8L16.25 11.5V15H15V9H16.25L18.75 12.5V9H20V15Z',
      key: '1qo599',
    },
  ],
]);

export default FiberPin;
